<template>
  <div id="search">
     <query
      ref="queryEditor"
      @update:type="onTypeChange"
      @result="onResult"
      @amend="onAmend"
    />

    <div class="container">
      <div v-masonry transition-duration="300ms" item-selector=".tile" v-if="results.length > 0">
        <div v-if="!SearchCardComponent">
          <h1 class="title">:( This entity does not have a Search Card Component...</h1>
          <h2 class="subtitle">Contact a developer.</h2>
        </div>
        <div
          v-else
          :is="SearchCardComponent"
          class="tile is-half"
          v-for="entity in results"
          :key="entity.id"
          :entity="entity"
        >
        </div>
      </div>
      <div v-else-if="loaded">
        <h1 class="title">
          :( There are no results...
        </h1>
        <h2 class="subtitle">Check your query to make sure you have good search conditions.</h2>
      </div>
      <div class="buttons is-right" v-if="hasNextPage">
        <button type="button" class="button is-success" @click="onLoadMore">Load More</button>
      </div>
    </div>
  </div>
</template>

<script>
import Library from '@/library'
import QueryComponent from '@/components/Query.vue'

export default {
  name: 'Search',

  props: {
    type: {
      required: false
    },

    query: {
      required: false
    },

    openEditor: {
      required: false
    }
  },

  data () {
    return {
      loaded: false,
      loading: false,
      results: []
    }
  },

  async mounted () {
    const queryEditor = this.$refs.queryEditor

    if (this.type) {
      queryEditor.setQuery(new Library.Classes.Query(this.type, {
        isLogicalUnion: true,
        rules: {},
        groups: []
      }))
    }

    if (this.openEditor) {
      queryEditor.setIsEditorOpen(true)
    }

    try {
      await queryEditor.runQuery()
    } catch (e) {
      throw e
    } finally {
      this.loaded = true
    }
  },

  methods: {
    onTypeChange (value) {
      const queryEditor = this.$refs.queryEditor

      this.$entity.toSearch(value, undefined, queryEditor.isEditorOpen || false)
    },

    onResult (entities) {
      this.results = entities

      this.$redrawMasonry()
    },

    onAmend (entities) {
      this.results.push(
        ...entities.filter(entity => {
          return !this.results.find(el => el.id === entity.id)
        })
      )
    },

    async onLoadMore () {
      if (this.hasNextPage && !this.loading) {
        this.loading = true
        const loader = this.$loading.open()
        try {
          await this.$refs.queryEditor.runQuery(this.currentPage + 1)
        } catch (e) {
          console.error(e)
        } finally {
          loader.close()
          this.loading = false
          this.$redrawMasonry()
        }
      }
    }
  },

  computed: {
    SearchCardComponent () {
      const queryEditor = this.$refs.queryEditor

      const type = queryEditor.type
      if (type) {
        return Library.Entities.getSearchCard(type)
      } else {
        return null
      }
    },

    currentPage () {
      return Math.max(Math.floor((this.results.length - 1) / 20) - 1, 0)
    },

    hasNextPage () {
      return (this.results.length - 1) % 20 === 0
    }
  },

  components: {
    Query: QueryComponent
  }
}
</script>
